import {AreaQueries} from '../../api/area'

export const AreaService = {queries: AreaQueries}
